module.exports = __webpack_public_path__ + "img/behance cover.68c98e9a.png";